<span *ngIf="type && value"
      class="sprite-icon"
      [ngClass]="'sprite-icon__' + type + '_' + value">
</span>
